import { DarkModeService } from './dark-mode.service';
import { DelayService } from './delay.service';

export { DarkModeService, DelayService };

export const SERVICES = [DarkModeService, DelayService];